import React from "react";
import { PrefillInput } from "@components/input";

const LastName = () => (
  <PrefillInput
    title="Last Name"
    placeholder="Last Name"
    name="lastName"
  />
);

export default LastName;
